import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import PendingMessage from '@src/interfaces/PendingMessage';

interface PendingMessagesState {
	value: PendingMessage[];
}

const initialState: PendingMessagesState = {
	value: [],
};

const pendingMessagesSlice = createSlice({
	name: 'pendingMessages',
	initialState,
	reducers: {
		failPendingMessage: (state, action: PayloadAction<string>) => {const message=state.value.find(m=>m.id===action.payload);if(message)message.isFailed=true;},
		addPendingMessage: (state, action: PayloadAction<PendingMessage>) => {state.value.push(action.payload);},
		removePendingMessage: (state, action: PayloadAction<string>) => {state.value=state.value.filter(m=>m.id!==action.payload);},
		setPendingMessages: (state, action: PayloadAction<PendingMessage[]>) => {
			state.value = action.payload;
		},
	},
});

export const { setPendingMessages, addPendingMessage, removePendingMessage, failPendingMessage } = pendingMessagesSlice.actions;

export default pendingMessagesSlice.reducer;
